<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
        <div class="text-center max-w-md mx-auto">
            <h1 class="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold text-gray-900">404</h1>
            <p class="text-xl sm:text-2xl font-medium text-gray-600 mt-4">Page Not Found</p>
            <p class="text-sm sm:text-base text-gray-500 mt-2">The page you're looking for doesn't exist or has been
                moved.</p>
            <div class="mt-6 sm:mt-8">
                <button @click="$router.push('/')"
                    class="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 bg-blue-600 text-white text-sm sm:text-base font-medium rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    Go to Dashboard
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundView'
}
</script>

<style scoped>
/* Add smooth transition for text scaling */
h1,
p {
    transition: font-size 0.3s ease;
}
</style>